const { REACT_APP_API_URL, REACT_APP_FOLDER_PATH } = process.env;

export const API_URL = REACT_APP_API_URL || "";
export const FOLDER_PATH = REACT_APP_FOLDER_PATH || "";
